import { SVGProps } from '../types';

const FileXlsxIcon = (props: SVGProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.6 0.45H16.2C16.2727 0.45 16.3425 0.478853 16.3939 0.530273L22.8697 7.00608C22.9211 7.0575 22.95 7.12728 22.95 7.2V21.6C22.95 22.6769 22.0769 23.55 21 23.55H6.6C5.52304 23.55 4.65 22.6769 4.65 21.6V2.4C4.65 1.32304 5.52305 0.45 6.6 0.45Z"
      fill="white"
      stroke="#DEDBD4"
      strokeWidth="1.25"
    />
    <path
      d="M16.2 0.3V4.8C16.2 6.12546 17.2745 7.2 18.6 7.2H23.1"
      stroke="#DEDBD4"
      strokeWidth="1.25"
    />
    <path
      d="M18.9 10.5H2.1C1.43726 10.5 0.9 11.0373 0.9 11.7V19.5C0.9 20.1627 1.43726 20.7 2.1 20.7H18.9C19.5627 20.7 20.1 20.1627 20.1 19.5V11.7C20.1 11.0373 19.5627 10.5 18.9 10.5Z"
      fill="#36863A"
    />
    <path
      d="M2.88755 17.7L4.62755 15.384V15.714L2.94755 13.47H3.85355L5.07155 15.156H4.82555L6.03756 13.47H6.94956L5.26355 15.714V15.384L7.00956 17.7H6.09756L4.81355 15.936H5.07755L3.79355 17.7H2.88755ZM7.42896 17.7V13.47H8.20296V17.046H10.195V17.7H7.42896ZM12.1745 17.76C11.8345 17.76 11.5205 17.718 11.2325 17.634C10.9484 17.546 10.7045 17.426 10.5005 17.274L10.7405 16.668C10.8764 16.764 11.0185 16.846 11.1665 16.914C11.3144 16.978 11.4725 17.028 11.6405 17.064C11.8085 17.096 11.9864 17.112 12.1745 17.112C12.4904 17.112 12.7184 17.06 12.8585 16.956C12.9985 16.852 13.0685 16.716 13.0685 16.548C13.0685 16.4 13.0205 16.288 12.9245 16.212C12.8285 16.132 12.6565 16.066 12.4085 16.014L11.7305 15.876C11.3425 15.796 11.0525 15.662 10.8605 15.474C10.6685 15.286 10.5725 15.034 10.5725 14.718C10.5725 14.454 10.6424 14.224 10.7825 14.028C10.9225 13.832 11.1185 13.68 11.3705 13.572C11.6225 13.464 11.9165 13.41 12.2525 13.41C12.5525 13.41 12.8305 13.454 13.0865 13.542C13.3424 13.626 13.5565 13.748 13.7285 13.908L13.4885 14.484C13.3165 14.34 13.1285 14.234 12.9245 14.166C12.7205 14.094 12.4925 14.058 12.2405 14.058C11.9564 14.058 11.7344 14.114 11.5745 14.226C11.4185 14.334 11.3405 14.484 11.3405 14.676C11.3405 14.824 11.3885 14.942 11.4845 15.03C11.5844 15.118 11.7524 15.186 11.9885 15.234L12.6605 15.366C13.0604 15.446 13.3565 15.578 13.5485 15.762C13.7405 15.942 13.8365 16.186 13.8365 16.494C13.8365 16.746 13.7684 16.968 13.6325 17.16C13.4965 17.348 13.3045 17.496 13.0565 17.604C12.8084 17.708 12.5144 17.76 12.1745 17.76ZM13.991 17.7L15.731 15.384V15.714L14.051 13.47H14.957L16.175 15.156H15.929L17.141 13.47H18.053L16.367 15.714V15.384L18.113 17.7H17.201L15.917 15.936H16.181L14.897 17.7H13.991Z"
      fill="white"
    />
  </svg>
);

export { FileXlsxIcon };
